import { Koi } from '@ksyos/koi';
import type { Section } from '@common/formEngine/formEngine.types';
import { DiaryTypes } from '@common/enums';
import { dependsOn } from '@common/formEngine/dependsOn';
import { imageAndPdfExtensions } from '@common/utils/fileExtensions';
import { getProcessActivityAssetsSchema, type ProcessActivityAsset } from '@common/validation/processActivityAsset';

export type HolterDiaryUploadData = {
    assets: ProcessActivityAsset[];
    diaryType: DiaryTypes;
    error?: string | null;
};

export const holterDiaryUploadSections: Section<HolterDiaryUploadData>[] = [
    {
        fields: [
            {
                isRequired: true,
                key: 'diaryType',
                label: 'Dagboek beschikbaar',
                type: 'radioGroup',
                valueOptions: [DiaryTypes.none, DiaryTypes.paperUpload],
            },
            {
                acceptExtensions: imageAndPdfExtensions,
                draftSchema: Koi.when('diaryType', {
                    is: DiaryTypes.paperUpload,
                    otherwise: getProcessActivityAssetsSchema(),
                    then: getProcessActivityAssetsSchema({ max: 25 }),
                }),
                finalSchema: Koi.when('diaryType', {
                    is: DiaryTypes.paperUpload,
                    otherwise: getProcessActivityAssetsSchema(),
                    then: getProcessActivityAssetsSchema({ max: 25, min: 1 }),
                }),
                include: dependsOn('diaryType', ({ diaryType }) => diaryType === DiaryTypes.paperUpload),
                isRequired: true,
                key: 'assets',
                label: 'Dagboek',
                maxFiles: 25,
                type: 'assets',
            },
            {
                isReadonly: true,
                key: 'error',
                label: 'error',
                type: 'textInput',
            },
        ],
    },
];
